import AboutUs from "./components/about-us/about-us.component"
import ContactPage from "./components/contact-page/contact-page.component"
// import Footer from "./components/footer/footer.component"
import MobileNavigation from "./components/mobile-navigation/mobile-navigation.component"
import Navigation from "./components/navigation/navigation.component"
import PreviewPage from "./components/preview-page/preview-page.component"
import ShortAdd from "./components/short-add/short-add.component"
import WhyUs from "./components/why-us-page/why-us.component"
import Services from "./components/services"
import Content from "./components/content/content";
import {WineContent} from "./components/content-wine/content-wine";
import {     GalleryContent} from "./components/content-gallery/gallery";
import {ContentDelivery} from "./components/content-delivery/content-delivery";

// import { useContext } from "react";
// import { CartContext } from "./contexts/cart.context";
function AllComponentsWrapper({ props, lang }) {
  const { navigation, previewPage, contactsPage } =
    props
    //console.log('props', props)
  // console.log('navigation', navigation)
  // console.log('whyUs', whyUs)
  // console.log('previewPage', previewPage)
  // const {isCartOpen} = useContext(CartContext);
    console.log(props)

  return (
    <div className="App">
      <MobileNavigation props={navigation} />
      <Navigation props={navigation} />
      <PreviewPage props={previewPage} />
        <Content props={lang}/>
        <WineContent />
        <GalleryContent />
        <ContentDelivery />
      <Services lang={lang} />
      <ContactPage props={contactsPage} />
    </div>
  )
}

export default AllComponentsWrapper
